// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS = {
  auth: '/auth',
  app: '/app',
  docs: '/docs'
};

export const PATH_PAGE = {
  auth: {
    root: ROOTS.auth,
    login: path(ROOTS.auth, '/login'),
    loginUnprotected: path(ROOTS.auth, '/login-unprotected'),
    register: path(ROOTS.auth, '/register'),
    registerrep: path(ROOTS.auth, '/register/:repid'),
    registerUnprotected: path(ROOTS.auth, '/register-unprotected'),
    resetPassword: path(ROOTS.auth, '/reset-password'),
    verify: path(ROOTS.auth, '/verify')
  },
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  privacy: '/privacy'
};

export const PATH_HOME = {
  components: '/components',
  cloud: 'https://www.sketch.com/s/0fa4699d-a3ff-4cd5-a3a7-d851eb7e17f0',
  purchase: 'https://material-ui.com/store/items/minimal-dashboard/',
  dashboard: ROOTS.app
};

export const PATH_APP = {
  root: ROOTS.app,
  general: {
    dashboard: path(ROOTS.app, '/dashboard'),
    ecommerce: path(ROOTS.app, '/ecommerce'),
    analytics: path(ROOTS.app, '/analytics')
  },
  app: {
    mail: {
      root: path(ROOTS.app, '/mail'),
      all: path(ROOTS.app, '/mail/all'),
      labels: [
        path(ROOTS.app, '/mail/label/:customLabel/:mailId?'),
        path(ROOTS.app, '/mail/:systemLabel/:mailId?')
      ]
    },
    chat: {
      root: path(ROOTS.app, '/chat'),
      new: path(ROOTS.app, '/chat/new'),
      conversation: [
        path(ROOTS.app, '/chat/new'),
        path(ROOTS.app, '/chat/:conversationKey')
      ]
    },
    calendar: path(ROOTS.app, '/calendar')
  },
  management: {
    root: path(ROOTS.app, '/management'),
    user: {
      root: path(ROOTS.app, '/management/user'),
      profile: path(ROOTS.app, '/management/user/profile'),
      cards: path(ROOTS.app, '/management/user/card'),
      list: path(ROOTS.app, '/management/user/list'),
      account: path(ROOTS.app, '/management/user/account')
    },
    eCommerce: {
      root: path(ROOTS.app, '/management/e-commerce'),
      products: path(ROOTS.app, '/management/e-commerce/products'),
      product: path(ROOTS.app, '/management/e-commerce/product/:name'),
      productById: path(
        ROOTS.app,
        '/management/e-commerce/product/nike-air-force-1-ndestrukt'
      ),
      list: path(ROOTS.app, '/management/e-commerce/list'),
      checkout: path(ROOTS.app, '/management/e-commerce/checkout'),
      invoice: path(ROOTS.app, '/management/e-commerce/invoice')
    },
    blog: {
      root: path(ROOTS.app, '/management/blog'),
      post: path(ROOTS.app, '/management/blog/post/:title'),
      postById: path(
        ROOTS.app,
        '/management/blog/post/portfolio-review-is-this-portfolio-too-creative'
      )
      //newPost: path(ROOTS.app, '/management/blog/new-post')
    }
  },
  foundations: {
    root: path(ROOTS.app, '/foundations'),
    colors: path(ROOTS.app, '/foundations/colors'),
    typography: path(ROOTS.app, '/foundations/typography'),
    shadows: path(ROOTS.app, '/foundations/shadows'),
    grid: path(ROOTS.app, '/foundations/grid'),
    icons: path(ROOTS.app, '/foundations/icons')
  },
  components: {
    root: path(ROOTS.app, '/components'),
    accordion: path(ROOTS.app, '/components/accordion'),
    alert: path(ROOTS.app, '/components/alert'),
    autocomplete: path(ROOTS.app, '/components/autocomplete'),
    avatar: path(ROOTS.app, '/components/avatars'),
    badge: path(ROOTS.app, '/components/badges'),
    breadcrumbs: path(ROOTS.app, '/components/breadcrumbs'),
    buttons: path(ROOTS.app, '/components/buttons'),
    chip: path(ROOTS.app, '/components/chips'),
    dialog: path(ROOTS.app, '/components/dialogs'),
    textfield: path(ROOTS.app, '/components/text-fields'),
    label: path(ROOTS.app, '/components/labels'),
    lists: path(ROOTS.app, '/components/lists'),
    menu: path(ROOTS.app, '/components/menu'),
    pagination: path(ROOTS.app, '/components/pagination'),
    pickers: path(ROOTS.app, '/components/pickers'),
    popover: path(ROOTS.app, '/components/popover'),
    progress: path(ROOTS.app, '/components/progress'),
    rating: path(ROOTS.app, '/components/rating'),
    selectionControls: path(ROOTS.app, '/components/selection-controls'),
    snackbar: path(ROOTS.app, '/components/snackbars'),
    slider: path(ROOTS.app, '/components/slider'),
    stepper: path(ROOTS.app, '/components/steppers'),
    tabs: path(ROOTS.app, '/components/tabs'),
    table: path(ROOTS.app, '/components/table'),
    timeline: path(ROOTS.app, '/components/timeline'),
    tooltip: path(ROOTS.app, '/components/tooltips'),
    transferList: path(ROOTS.app, '/components/transfer-list'),

    // Extra
    chart: path(ROOTS.app, '/extra-components/chart'),
    map: path(ROOTS.app, '/extra-components/map'),
    editor: path(ROOTS.app, '/extra-components/editor'),
    copyToClipboard: path(ROOTS.app, '/extra-components/copy-to-clipboard'),
    upload: path(ROOTS.app, '/extra-components/upload'),
    carousel: path(ROOTS.app, '/extra-components/carousel'),
    multiLanguage: path(ROOTS.app, '/extra-components/multi-language'),
    animate: path(ROOTS.app, '/extra-components/animate')
  },
  // Playz
  news: {
    home: path(ROOTS.app, '/news'),
    searchbase: path(ROOTS.app, '/search'),
    search: path(ROOTS.app, '/search/:sport?/:tag?'),
    newPost: path(ROOTS.app, '/story/new'),
    id: path(ROOTS.app, '/news/:newsid'),
    story: path(ROOTS.app, '/story/'),
    edit: path(ROOTS.app, '/story/:postid')
  },
  profile: {
    home: path(ROOTS.app, '/profile'),
    id: path(ROOTS.app, '/profile/:profileid')
  },
  fans: {
    home: path(ROOTS.app, '/fans')
  },
  media: {
    home: path(ROOTS.app, '/media')
  },
  calendar: {
    home: path(ROOTS.app, '/calendar')
  },
  card: {
    edit: path(ROOTS.app, '/card'),
    home: path(ROOTS.app, '/cards')
  },
  cards: {
    new: path(ROOTS.app, '/card/new'),
    edit: path(ROOTS.app, '/card/:cardid'),
    home: path(ROOTS.app, '/cards')
  },
  team: {
    home: path(ROOTS.app, '/team'),
    site: path(ROOTS.app, '/team/:groupid'),
  },
  teams: {
    new: path(ROOTS.app, '/team/new'),
    edit: path(ROOTS.app, '/team/:groupid'),
    home: path(ROOTS.app, '/teams')
  },
  settings: {
    home: path(ROOTS.app, '/settings'),
    tab: path(ROOTS.app, '/settings/:tab?')
  },
  reps: {
    home: path(ROOTS.app, '/reps'),
    tab: path(ROOTS.app, '/reps/:tab?'),
    order: path(ROOTS.app, '/reps/orders/:orderid'),
    orders: path(ROOTS.app, '/reps/orders')
  },
  printers: {
    home: path(ROOTS.app, '/printers'),
    tab: path(ROOTS.app, '/printers/:tab?'),
    order: path(ROOTS.app, '/printers/orders/:orderid'),
    orders: path(ROOTS.app, '/printers/orders')
  },
  checkout: {
    home: path(ROOTS.app, '/checkout')
  },
  members: {
    page: path(ROOTS.app, '/members/page/:pageid'),
    events: path(ROOTS.app, '/members/events'),
    training: path(ROOTS.app, '/members/training')
  },
  orders: {
    new: path(ROOTS.app, '/orders/new'),
    edit: path(ROOTS.app, '/orders/edit/:orderid'),
    id: path(ROOTS.app, '/orders/:orderid'),
    home: path(ROOTS.app, '/orders'),
    card: path(ROOTS.app, '/orders/card/:cardid')
  },
  search: {
    home: path(ROOTS.app, '/searchall')
  },  
  // ADMIN
  admin: {
    users: path(ROOTS.app, '/admin/users'),
    user: path(ROOTS.app, '/admin/user/:userid'),
    usernew: path(ROOTS.app, '/admin/user'),
    categories: path(ROOTS.app, '/admin/categories'),
    category: path(ROOTS.app, '/admin/category/:categoryid'),
    categorynew: path(ROOTS.app, '/admin/category'),
    levels: path(ROOTS.app, '/admin/levels'),
    level: path(ROOTS.app, '/admin/level/:levelid'),
    levelnew: path(ROOTS.app, '/admin/level'),
    modules: path(ROOTS.app, '/admin/modules'),
    module: path(ROOTS.app, '/admin/module/:moduleid'),
    modulenew: path(ROOTS.app, '/admin/module'),
    events: path(ROOTS.app, '/admin/events'),
    event: path(ROOTS.app, '/admin/event/:eventid'),
    eventnew: path(ROOTS.app, '/admin/event'),
    pages: path(ROOTS.app, '/admin/pages'),
    page: path(ROOTS.app, '/admin/page/:pageid'),
    pagenew: path(ROOTS.app, '/admin/page'),
    documents: path(ROOTS.app, '/admin/documents'),
    document: path(ROOTS.app, '/admin/document/:documentid'),
    documentnew: path(ROOTS.app, '/admin/document'),
    questions: path(ROOTS.app, '/admin/questions'),
    question: path(ROOTS.app, '/admin/question/:questionid'),
    questionnew: path(ROOTS.app, '/admin/question')
  }
};

export const PATH_DOCS = {
  root: ROOTS.docs,
  introduction: path(ROOTS.docs, '/introduction'),
  started: path(ROOTS.docs, '/getting-started'),
  package: path(ROOTS.docs, '/package'),
  // Theme UI
  color: path(ROOTS.docs, '/color'),
  typography: path(ROOTS.docs, '/typography'),
  icon: path(ROOTS.docs, '/icon'),
  shadows: path(ROOTS.docs, '/shadows'),
  components: path(ROOTS.docs, '/components'),
  tips: path(ROOTS.docs, '/tips'),

  // Development
  routing: path(ROOTS.docs, '/routing'),
  environmentVariables: path(ROOTS.docs, '/environment-variables'),
  stateManagement: path(ROOTS.docs, '/state-management'),
  apiCalls: path(ROOTS.docs, '/api-calls'),
  analytics: path(ROOTS.docs, '/analytics'),
  authentication: path(ROOTS.docs, '/authentication'),
  multiLanguage: path(ROOTS.docs, '/multi-language'),
  lazyload: path(ROOTS.docs, '/lazyload-image'),
  formHelper: path(ROOTS.docs, '/form-helper'),

  // Changelog
  support: path(ROOTS.docs, '/support'),
  changelog: path(ROOTS.docs, '/changelog')
};
